@switch (messageType) {
  @case ('ollieHelp') {
    <div class="ollie-help">
      @for (item of formattedContent; track $index) {
        <span>{{ item }}</span>
      }
    </div>
  }

  @case ('person') {
    <div class="person">
      @for (item of formattedContent; track $index) {
        <span>{{ item }}</span>
      }
    </div>
  }

  @default {
    <ol class="ollie-list">
      @for (chat_item of formattedContent; track $index) {
        <li>{{ chat_item }}</li>
      }
    </ol>
  }
}